import React from 'react';
import { Button } from '@grubhubprod/gh-cookbook-react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';

const SIGN_OUT_REDIRECT_URL = 'https://business.grubhub.com/';

export function SignOutButton(): JSX.Element {
  const { signOut } = useAuth();

  return (
    <Button
      variant="tertiary"
      onClick={() => signOut(SIGN_OUT_REDIRECT_URL)}
      className="removeButtonPadding autoButtonHeight"
      buttonSize="small"
    >
      Sign out
    </Button>
  );
}
